import React, { ReactNode } from "react";
import { Container, Paper, Box } from "@mui/material";
import Title from "./title";

export default function Page({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) {
  return (
    <Container maxWidth={false} sx={{ pt: 4, pb: 4 }}>
      <Box
        sx={{
          width: "100%",
          mx: "auto",
          // Narrower than before, but still responsive
          maxWidth: {
            xs: "100%", // phones
            sm: "100%", // small tablets
            md: "900px", // laptops
            lg: "1000px",
            xl: "1100px",
          },
        }}
      >
        <Paper
          sx={{
            p: 2,
            position: "sticky",
            top: 0,
            zIndex: 130,
            backgroundColor: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
          }}
        >
          <Title>{title}</Title>
          {children}
        </Paper>
      </Box>
    </Container>
  );
}
